<template>
  <Marquee v-if="brandconfig.usps?.length" :class="classes">
    <div v-for="usp in brandconfig.usps" class="flex items-center gap-1 text-sm">
      <component :is="usp.icon" v-if="usp.icon" class="size-6" /> {{ $t(usp.text) }}
    </div>
  </Marquee>
</template>

<script setup lang="ts">
import clsx from "clsx";
import { computed } from "vue";
import Marquee from "./Marquee.vue";
import brandconfig from "@/brandconfig";
// TODO: Add google reviews

const props = withDefaults(defineProps<{ color?: "primary" | "accent" }>(), { color: "primary" });

const classes = computed(() => {
  return clsx("p-2 flex gap-6 items-center", {
    "bg-primary text-primary-foreground": props.color == "primary",
    "bg-accent text-foreground": props.color == "accent",
  });
});
</script>
